<template>
    <div class="expand-row">
        <span style="padding-bottom: 4px">该分类下还有：</span>
        <Table
            :max-height="400"
            :columns="columns1"
            :data="row"
            ref="list">
        </Table>
    </div>
</template>

<script>
export default {
    props: {
        row: Array
    },
    data() {
        return {
            columns1: [
                {
                    title: '物资名称',
                    key: 'productName',
                    width: 200
                },
                {
                    title: '物资规格',
                    key: 'productSpectype',
                    width: 200
                },
                {
                    title: '物资单位',
                    key: 'productUnit',
                    width: 200
                },
                {
                    title: '物资描述',
                    key: 'productSpec'
                }
            ]
        };
    }
};
</script>



// WEBPACK FOOTER //
// src/views/review/table-expand.vue